import Vue from "vue";
import Vuetify from "vuetify";

// VCurrencyField
import VCurrencyField from "v-currency-field";
Vue.use(VCurrencyField, {
    locale: "kr-KR",
    decimalLength: 0,
    autoDecimalMode: false,
    defaultValue: 0,
    min: null,
    max: null,
    valueAsInteger: false,
    allowNegative: true,
});

Vue.use(Vuetify);

export const basicTheme = {
    themes: {
        light: {
            primary: {
                lighten5: "#E0E6F6",
                lighten4: "#B3C2E9",
                lighten3: "#8099DA",
                lighten2: "#4D70CB",
                lighten1: "#2651BF",
                base: "#0032B4",
                darken1: "#002DAD",
                darken2: "#0026A4",
                darken3: "#001F9C",
                darken4: "#00138C",
            },
            secondary: {
                lighten5: "#FCE4EC",
                lighten4: "#F8BCD0",
                lighten3: "#F48FB1",
                lighten2: "#F06292",
                lighten1: "#EC407A",
                base: "#E91E63",
                darken1: "#E61A5B",
                darken2: "#E31651",
                darken3: "#DF1247",
                darken4: "#D90A35",
            },
            accent: {
                lighten5: "#E5ECFF",
                lighten4: "#BFD0FF",
                lighten3: "#94B1FF",
                lighten2: "#6991FF",
                lighten1: "#497AFF",
                base: "#2962FF",
                darken1: "#245AFF",
                darken2: "#1F50FF",
                darken3: "#1946FF",
                darken4: "#0F34FF",
            },
            grey: {
                lighten5: "#F7F7F7",
                lighten4: "#ECECEC",
                lighten3: "#DDD",
                lighten2: "#AAA",
                lighten1: "#999",
                base: "#666",
                darken1: "#555",
                darken2: "#444",
                darken3: "#333",
                darken4: "#111",
            },
            success: "#4CAF50",
            warning: "#FFC107",
            error: "#FF5252",
            info: "#2196F3",
            anchor: "inherit",
        },
    },
    options: { customProperties: true },
};

export const consoleTheme = {
    themes: {
        light: {
            primary: "#00C73C",
            secondary: "#445163",
            accent: "#00C73C",
            info: "#2D3539",
            content: "#EDF0F5",
            anchor: "#333",
        },
    },
};

/**
 *
 * @param {(basicTheme|consoleTheme)} theme
 * @returns
 */
export default function (theme) {
    return new Vuetify({
        lang: {
            locales: { ko: require("vuetify/lib/locale/ko") },
            current: "ko",
        },
        breakpoint: {
            mobileBreakpoint: "md",
            thresholds: {
                xs: 576,
                sm: 768,
                md: 1024,
                lg: 1200,
            },
            scrollBarWidth: 0,
        },
        theme: theme || basicTheme,
    });
}
